import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getData } from "../store/utils";
import Swal from "sweetalert2";
import { useDebounce } from 'use-debounce';

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "none",
        padding: "0px",
        minWidth: "90%",
        maxWidth: "90%",
    },
};

function Items() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [orderList, setOrderList] = useState([]);
    const [text, setText] = useState('');
    const [value] = useDebounce(text, 1000);

    // const [orderList, setOrderList] = useState([]);
    // const [text, setText] = useState('');
    // const [value] = useDebounce(text, 500);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    // const [isLoadingOn, setIsLoadingOn] = useState(false);


    async function getItemList({ page = 1, pageSize = 20, productName = "", productId = "", isLoadMore = false }) {
        setIsLoadingOn(true);

        // Construct query params dynamically
        const params = new URLSearchParams();
        if (productName) params.append("search", productName);
        if (productId) params.append("productId", productId);
        params.append("page", page);
        params.append("pageSize", pageSize);

        console.log(productName, productId)

        const tempData = await getData(`inventory/getInventoryItem?${params.toString()}`);
        // const tempData = await getData(`inventory/getInventoryItem`);
        setIsLoadingOn(false);

        if (tempData?.statusCode === 200) {
            const records = tempData?.data?.records || [];

            setOrderList(prev => {
                if (isLoadMore) {
                    return [...prev, ...records]; // Append for infinite scroll
                } else {
                    return records; // Reset list for new search or first load
                }
            });

            return {
                hasMore: records.length === pageSize,
            };
        } else {
            setOrderList([]);
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!",
            });
            return { hasMore: false };
        }
    }


    useEffect(() => {
        setIsSearching(value !== ''); // set true if searching
        // getPurchaseOrder(value);      // fetch data based on debounced value
    }, [value]);

    useEffect(() => {
        setPage(1);
        getItemList({ page: 1, productName: value });
    }, [value]);

    const filterPurchaseOrder = (e) => {
        setText(e.target.value);
    }

    useEffect(() => {
        const handleScroll = () => {
            const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;

            if (bottom && hasMore && !isLoadingOn) {
                const nextPage = page + 1;
                setPage(nextPage);
                getItemList({ page: nextPage, vendorName: value, isLoadMore: true });
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [page, hasMore, value, isLoadingOn]);


    return (
        <div className="purchaseOrderSec purchaseListSec">
            <div>
                {isLoadingOn ? <Loader /> : ""}

                {Array.isArray(orderList) && orderList.length > 0 && (
                    <div className="filter mb-3">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Items"
                                    // onChange={(e) => filterPurchaseOrder(e)}
                                    onChange={(e) => setText(e.target.value)}

                                />
                            </div>
                        </div>
                    </div>
                )}
                <div className="d-flex justify-content-between align-items-center">
                    <h4>All Items</h4>
                    <div>
                        {/* <button className="btn btn-outline-primary transitbtnbg">In Transit Receives</button> */}
                        <Link to={'/inventory/new'}><button className="btn btn-primary mx-2">
                            + New
                        </button>
                        </Link>
                        {/* <button className="btn btn-light">⋮</button> */}
                    </div>
                </div>

                <div className="purchaseorderTable">
                    <div className="table-container">
                        <div className="table-scroll">
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ width: "80px" }} className="checkbox-cell"><input type="checkbox" /></th>
                                        <th style={{ width: "200px" }}>PRODUCT NAME</th>
                                        <th style={{ width: "300px" }}>SKU</th>
                                        <th style={{ width: "200px" }}>STOCK IN HAND</th>
                                        <th style={{ width: "300px" }}>REORDER LEVEL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderList && orderList.length > 0 ? (
                                        orderList.map((item, index) => (
                                            <tr key={index} className="table-row">
                                                <td className="checkbox-cell"><input type="checkbox" /></td>
                                                
                                                <td>
                                                    <Link to={`/inventoryDetails/${item?.id}`} className="vendor-name">
                                                        {item?.productName}
                                                    </Link>
                                                </td>
                                                <td>{item?.sku}</td>
                                                <td>{item?.stockInHand ?? ''}</td>
                                                <td></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center text-gray-500 py-4">
                                                No Inventory Item to display!
                                            </td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Items;
